import { Config } from "@modules/config"
import * as Sentry from "@sentry/react"

export class LoggerService {
  static captureException(name: string, error: unknown) {
    if (Config.ENV === "dev") {
      console.error("[SENTRY Exception] " + name, error)
    }

    if (error instanceof Error) {
      error.name = `${name} - ${error.name}`

      Sentry.captureException(error, {
        contexts: {
          Error: {
            Message: error.message,
          },
        },
      })

      return
    }
    Sentry.captureException(error)
  }
}
